import React from 'react';

interface Props {
    namespace: string;
    srcRoot: string;
    config: Record<string, unknown>;
    isNative: boolean;
    frontpage: boolean;
}

const HeaderApp: React.FC<Props> = ({ namespace, srcRoot, config, isNative, frontpage }) => {
    return (
        <script
            data-react={namespace}
            data-src={`${srcRoot}/app.js`}
            data-css-src={config.isLocal ? '' : `${srcRoot}/app.css`}
            type="text/json"
        >
            {JSON.stringify({ ...config, isNative, frontpage })}
        </script>
    );
};

export default HeaderApp;
